import { Button } from "web/components"

export default function FindComparablesButton({ baseURL }) {
  return (
    <Button onClick={() => window.Turbo.visit(`${baseURL}/find`)}>
      Find Comparables
    </Button>
  )
}
